import './foundation.js'
import './vendors/sniff.min.js'
import './vendors/browser-notification.js'
import '@/assets/sass/app.scss'
require('./analytics');

const $ = require("jquery");
const Flickity = require('flickity-imagesloaded');

const flky = new Flickity('.carousel', {
    imagesLoaded: true,
    prevNextButtons: false,
    wrapAround: true,
    cellAlign: 'left',
});

flky.on( 'pointerDown', function( event, pointer ) {
    flky.next();
});

const flkyTwitter = new Flickity('.twitter-list', {
    imagesLoaded: true,
    prevNextButtons: false,
    pageDots: false,
    initialIndex: 3,
    wrapAround: true
});

document.querySelector('.hamburger').addEventListener('click', (e) => {
    e.preventDefault();
    document.querySelector('.hamburger').classList.toggle('is-active');
    document.querySelector('#wrapper').classList.toggle('is-active');
});



// WEBPACK FOOTER //
// ./assets/js/app.js